import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/auth/Login.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/prijava',
        name: 'login',
        component: Login
    },
    {
        path: '/password-reset',
        name: 'passwordResetRequest',
        component: () => import('@/views/auth/PasswordResetRequest.vue')
    },
    {
        //path: '/ponastavitev-gesla/:token',
        path: '/password-reset/:token',
        name: 'passwordReset',
        component: () => import('@/views/auth/PasswordReset.vue')
    }, 
    /* ERRORS */
    {
        path: '*',
        name: '404',
        component: () => import('@/views/errors/404.vue')
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/views/errors/403.vue')
    },
    {
        path: '/500',
        name: '500',
        component: () => import('@/views/errors/500.vue')
    },

    {
        path: '/',
        component: () => import('@/views/RootView.vue'),
        children: [
            {
                path: 'invoices',
                name: 'dashboard' ,
                component: () => import('@/views/Dashboard.vue'),
                alias: '',
                meta: { requiresAuth: true}
            },

            {
                path: 'qr-codes',
                name: 'qr_codes' ,
                component: () => import('@/views/QrCodes.vue'),
                alias: '',
                meta: { requiresAuth: true}
            },
            
            /*{
                path: 'nastavitve',
                name: 'settings',
                component: () => import('@/views/Settings.vue'),
                meta: { requiresAuth: true }
            },*/
            

            {
                path:'exports',
                name: 'exports',
                component: () => import('@/views/Exports.vue'),
                meta: { requiresAuth: true, permissions: [] }
            }
        ]
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: function(to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 }
    },
    linkActiveClass: 'v-list__tile--active router-link-active active',
    routes
})

export default router